import React from "react";
import PropTypes from "prop-types";
import Period from "./Period";
import Lecture from "./Lecture";
import Weekend from "./Weekend";
import { useTranslation } from "react-i18next";

const TimeTableGridView = ({ data }) => {
  const { Periods = [], Lectures = {} } = data || {};
  const { t } = useTranslation();
  const {
    Monday = [],
    Tuesday = [],
    Wednesday = [],
    Thursday = [],
    Friday = [],
  } = Lectures;

  const weekDaysColor = {
    MondayColor: { bgColor: "monday" },
    TuesdayColor: { bgColor: "tuesday" },
    WednesdayColor: { bgColor: "wednesday" },
    ThursdayColor: { bgColor: "thursday" },
    FridayColor: { bgColor: "friday" },
  };

  const weekDays = [
    { Id: 0, Name: t("Periods") },
    { Id: 1, Name: t("Monday") },
    { Id: 2, Name: t("Tuesday") },
    { Id: 3, Name: t("Wednesday") },
    { Id: 4, Name: t("Thursday") },
    { Id: 5, Name: t("Friday") },
    { Id: 6, Name: t("Saturday") },
    { Id: 7, Name: t("Sunday")},
  ];

  return (
    <div className="tt-box">
      <div className="tt-row">
        {weekDays.map((day) => (
          <div
            key={day.Id}
            className={`tt-col${
              day.Id !== 0 ? ` ${day.Name.toLowerCase()}` : ""
            }`}
          >
            <div className="tt-title">
              <div className="tt-title-inner">
                <div className="title">{day.Name}</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      { Periods?.length > 0 ? (Periods.map((period, i) => {
        if (!period) return null;

        if (period.isInterval) {
          return (
            <div key={`break-${i}`} className="break-row">
              <span className="break-time">
                {period.startTime || ""} - Break - {period.endTime || ""}
              </span>
            </div>
          );
        }

        return (
          <div key={`period-${i}`} className="tt-row">
        
            <Period data={period} />
            <Lecture data={Monday?.[i]} Color={weekDaysColor.MondayColor} />
            <Lecture data={Tuesday?.[i]} Color={weekDaysColor.TuesdayColor} />
            <Lecture
              data={Wednesday?.[i]}
              Color={weekDaysColor.WednesdayColor}
            />
            <Lecture data={Thursday?.[i]} Color={weekDaysColor.ThursdayColor} />
            <Lecture data={Friday?.[i]} Color={weekDaysColor.FridayColor} />
            <Weekend />
            <Weekend />
          </div>
        );
      }) ) : (<div className="details-bookmark text-center">
              <span>No records found.</span>
            </div>)}
    </div>
  );
};

TimeTableGridView.propTypes = {
  data: PropTypes.shape({
    Periods: PropTypes.array,
    Lectures: PropTypes.object,
  }),
};

TimeTableGridView.defaultProps = {
  data: {
    Periods: [],
    Lectures: {},
  },
};

export default TimeTableGridView;
